import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import ProductSearchOverlay from '../components/products/ProductSearchOverlay';

const ProductSearchContext = createContext(null);

export function ProductSearchProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openSearch = useCallback(() => setOpen(true), []);
  const closeSearch = useCallback(() => setOpen(false), []);

  const value = useMemo(
    () => ({ openSearch, closeSearch }),
    [openSearch, closeSearch]
  );

  return (
    <ProductSearchContext.Provider value={value}>
      {children}
      <ProductSearchOverlay open={open} onClose={closeSearch} />
    </ProductSearchContext.Provider>
  );
}

export default function useProductSearch() {
  const ctx = useContext(ProductSearchContext);
  if (!ctx) {
    throw new Error('useProductSearch must be used within ProductSearchProvider');
  }
  return ctx;
}
